import axios from "axios";
import moment from "moment";
import { API } from "../../constants";

// get all students
export const getStudentsList = (gradeList: string) => {
    return axios.get(API + `items/student_profile_grade_section?filter[grade_section_id][in]=${gradeList}&fields=student_profile_id.user.id`)
}; 

// get particular ticket/grievance details
export const getTicketDetails = (ticket_id: number) => {
    return axios.get(API + `items/ticket?filter[id]=${ticket_id}&fields=id,query,status,subject.*,user.id,user.email,user.first_name,user.last_name,user.avatar.*&single=1`);
};

// get comments for particular ticket/grievance
export const getComments = (ticket_id: number) => {
    return axios.get(API + `items/comment?filter[ticket]=${ticket_id}`);
};

// add a comment
export const postNewComment = (comment: {
    user: number,
    text: string,
    ticket: number
}) => {
    return axios.post(API + 'items/comment', comment);
};

// close a ticket
export const closePendingTicket = (ticket_id: number) => {
    let closeObj = {
        status: 'closed',
        resolved_on: moment().format("YYYY-MM-DD")
    };
    return axios.patch(API +`items/ticket/${ticket_id}`, closeObj);
};